import React, { Fragment } from 'react';
import { graphql, withPrefix } from 'gatsby';
import PropTypes from 'prop-types';
import {
  PageHeader,
  SimpleDataTable,
  Section,
  toLineItem,
  toSectionsURL
} from '@budget-monorepo/shared-ui';
import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

const LineItemPage = (props) => {
  const { data, location } = props;
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent;

  const layoutProps = {
    activeIndex: 1,
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };

  const metaTitle = content.title;
  const tableHeaders = content.summaryTable.headers.map((header) => header.name).join(', ');
  const metaDescription = `View all line items data by ${tableHeaders}. Filter and sort line items by line item number and name.`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        metaType: 'dataset',
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        {
          () => {
            const tableProps = {
              filterable: true,
              headers: content.summaryTable.headers,
              data: []
            };
            const lineItemsMax = content.lineItems.length;
            let i = 0;
            for (; i < lineItemsMax; i += 1) {
              const item = content.lineItems[i];
              // Filter out any line items without spending category table data.
              if (item && item.spendingCategory) {
                const {
                  govLevelOne, govLevelTwo, govLevelThree, lineItemNumber
                } = item;
                const slug = toSectionsURL({
                  href: '/appropriations/',
                  sections: govLevelOne === govLevelTwo ? [govLevelOne, govLevelThree, lineItemNumber] : [govLevelOne, govLevelTwo, govLevelThree, lineItemNumber]
                });
                const [spending] = item.spendingCategory.data;
                const { fyOneYearsAgo, fyHouse } = spending;
                tableProps.data.push({
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  lineItemNumber: (<a href={withPrefix(slug)}>{toLineItem(item.lineItemNumber)}</a>),
                  lineItemName: item.lineItemName,
                  fyOneYearsAgo,
                  fyHouse,
                  comment: item.comment || ''
                });
              }
            }
            return(
              <Section>
                <SimpleDataTable title={content.title} table={tableProps} maxColWidth={100} pagination pageSize={50} download={location.pathname} />
              </Section>
            );
          }
        }
      </Layout>
    </Fragment>
  );
};

LineItemPage.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object
};

export default LineItemPage;

export const query = graphql`
  query LineItemPageQuery {
    site {
      ...SiteMetadata
    }
    content: pagesJson(fields: { slug: { eq: "/line-item/" } }) {
      title
      budgetSection
      summaryTable {
        headers {
          name
          type
          align
          value
        }
      }
      lineItems {
        lineItemNumber
        lineItemName
        govLevelOne
        govLevelTwo
        govLevelThree
        comment
        spendingCategory {
          data {
            fyOneYearsAgo
            fyHouse
          }
        }
      }
      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
  }
`;
